exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-63fbc2bd] .el-card__body{height:100%}.card__body--nopadding[data-v-63fbc2bd]  .el-card__body{padding:10px}", ""]);

// exports
